import React, { useState } from 'react';
import { PitchDeck } from './pages/PitchDeck';
import { ProspectPresentation } from './pages/ProspectPresentation';
import { Presentation, Users } from 'lucide-react';
export function App() {
  const [mode, setMode] = useState<'investor' | 'prospect'>('prospect');
  return <div className="relative w-full h-screen overflow-hidden" data-id="element-0">
      {/* Mode Switcher - Absolute positioned to float above presentation */}
      <div className="absolute top-4 left-1/2 -translate-x-1/2 z-50 bg-white/10 backdrop-blur-md border border-white/20 p-1 rounded-full flex gap-1 shadow-2xl" data-id="element-1">
        <button onClick={() => setMode('prospect')} className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all ${mode === 'prospect' ? 'bg-white text-indigo-600 shadow-sm' : 'text-white/70 hover:text-white hover:bg-white/10'}`} data-id="element-2">
          <Users className="w-4 h-4" data-id="element-3" />
          Prospects
        </button>
        <button onClick={() => setMode('investor')} className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all ${mode === 'investor' ? 'bg-white text-indigo-600 shadow-sm' : 'text-white/70 hover:text-white hover:bg-white/10'}`} data-id="element-4">
          <Presentation className="w-4 h-4" data-id="element-5" />
          Investors
        </button>
      </div>

      {mode === 'investor' ? <PitchDeck data-id="element-6" /> : <ProspectPresentation data-id="element-7" />}
    </div>;
}